<template>
    <div class="float-left mr-1">
        <span class="text-success">
            <i
                class="fa fa-check-circle fa-lg icon-button mr-1"
                title="Aprovar"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal" size="lg">
            <b-alert
                show
                variant="warning"
                v-if="!comprometimento.permiteAprovar"
            >
                <h5>Atenção</h5>
                <p>
                    É necessario um documento do tipo LISTA para aprovar
                    esse serviço.
                </p>
            </b-alert>
            <div slot="modal-title">
                Aprovar Serviço - {{ comprometimento.idComprometimento }}
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <comprometimento-dados
                        :comprometimento="comprometimento"
                    ></comprometimento-dados>
                    <comprometimento-documentacao
                        class="mt-4"
                        v-model="comprovacoes"
                        :comprometimento="comprometimento"
                        v-if="comprometimento.contratoTipoEspecial"
                    ></comprometimento-documentacao>
                    <comprometimento-pesquisa
                        class="mt-2"
                        v-model="avaliacoes"
                        :comprometimento="comprometimento"
                    >
                    </comprometimento-pesquisa>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Cancelar</b-button
                >
                <btn-aprovar
                    class="ml-2"
                    :comprometimento="comprometimento"
                    :comprovacoes="comprovacoes"
                    :avaliacoes="avaliacoes"
                    :dataServico="dataServico"
                    @obter-atualizacao="$emit('obter-atualizacao')"
                ></btn-aprovar>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ComprometimentoDocumentacao from './ComprometimentoDocumentacao'
import ComprometimentoPesquisa from './ComprometimentoPesquisa'
import ComprometimentoDados from './ComprometimentoDados'
import BtnAprovar from './BtnAprovar'

export default {
    components: {
        ComprometimentoDocumentacao,
        ComprometimentoPesquisa,
        ComprometimentoDados,
        BtnAprovar
    },

    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        },

        dataServico: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            comprovacoes: null,
            avaliacoes: null
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
            console.log(this.comprometimento)
        },

        fecharModal() {
            this.mostrarModal = false
        },

        
    }
}
</script>
